const is = require('../plugins/helper/is')
const { initSW } = require('../../plugins/push')
const { listen } = require('../plugins/event/listen')
const Swal = require('../plugins/sweet/Alert').default

let cedulaImage = null
let cedulaReversoImage = null
let fichaImage = null
let talonarioImage = null
let cartaTrabajoImage = null
let reciboImage = null
let firmaImagen = null

let comprobantePagoImage = null

let cedulasBeneficiarios = []
const maximoCedulasBeneficiariosMIVI = 5
let cantidadCedulasBeneficiariosMIVI = 1

const defaultSwal = {
  toast: true,
  timer: 2000,
  position: 'top-start',
  showConfirmButton: false,
  timerProgressBar: false,
}

const cedulaImageInput = is.getNode('#archivo_cedula')
const cedulaReversoImageInput = is.getNode('#archivo_cedula_reverso')
const fichaImageInput = is.getNode('#ficha')
const talonarioImageInput = is.getNode('#talonario')
const cartaTrabajoImageInput = is.getNode('#carta_trabajo')
const reciboImageInput = is.getNode('#recibo')
const firmaImageInput = is.getNode('#archivo_firma')

const comprobantePagoImageInput = is.getNode('#archivo_comprobante')
const montoPagadoInput = is.getNode('#monto_pagado')

const spinnerCedula = is.getNode('#spinner-cedula')
const spinnerCedulaReverso = is.getNode('#spinner-cedula-reverso')
const spinnerFicha = is.getNode('#spinner-ficha')
const spinnerTalonario = is.getNode('#spinner-talonario')
const spinnerCartaTrabajo = is.getNode('#spinner-carta-trabajo')
const spinnerRecibo = is.getNode('#spinner-recibo')
const spinnerArchivoFirma = is.getNode('#spinner-archivo_firma')

const spinnerComprobantePago = is.getNode('#spinner-comprobante')

const validationMessagesDiv = is.getNode('#validation-messages')
const buttonSubmit = is.getNode('#button-submit')
const destino = is.getNode('#destino')

const inputGroupCedulaBeneficiario = is.getNode('.inputGroupCedulaBeneficiario')
const divContenedorCedulasBeneficiarios = is.getNode('#containerMIVIBondCedulas')
const buttonAgregarCedulaBeneficiario = is.getNode('#buttonAddMIVIBondCedula')

const indicadorCedula = is.getNode('#indicador-cedula')
const nombreArchivoCedula = is.getNode('#nombre-archivo-cedula')
const indicadorCedulaReverso = is.getNode('#indicador-cedula-reverso')
const nombreArchivoCedulaReverso = is.getNode('#nombre-archivo-cedula-reverso')
const indicadorFicha = is.getNode('#indicador-ficha')
const nombreArchivoFicha = is.getNode('#nombre-archivo-ficha')
const indicadorTalonario = is.getNode('#indicador-talonario')
const nombreArchivoTalonario = is.getNode('#nombre-archivo-talonario')
const indicadorCartaTrabajo = is.getNode('#indicador-carta-trabajo')
const nombreArchivoCartaTrabajo = is.getNode('#nombre-archivo-carta-trabajo')
const indicadorRecibo = is.getNode('#indicador-recibo')
const nombreArchivoRecibo = is.getNode('#nombre-archivo-recibo')

/**
 * @param {HTMLElement} indicador
 * @param {HTMLElement} nombreEl
 * @param {string} fileName
 */
const mostrarIndicadorExito = (indicador, nombreEl, fileName) => {
  if (is.node(indicador) && is.node(nombreEl)) {
    nombreEl.textContent = fileName
    indicador.style.display = 'flex'
  }
}

/**
 * @param {HTMLElement} input
 */
const setAsLoaded = (input, title) => {
  is.addClass(input.parentNode, 'disable-file-select')
  is.setAttribute(input, 'disabled', 'disabled')
  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'info',
    title,
  })
}

if (is.node(cedulaImageInput)) {
  cedulaImageInput.onchange = async function () {
    const fileName = this.files[0]?.name || ''
    cedulaImage = await is.asyncHandleFileSelected(cedulaImageInput, null, spinnerCedula, buttonSubmit)
    if (is.file(cedulaImage)) {
      setAsLoaded(cedulaImageInput, 'Cédula/Pasaporte adjuntada correctamente.')
      mostrarIndicadorExito(indicadorCedula, nombreArchivoCedula, fileName)
    }
  }
}
if (is.node(cedulaReversoImageInput)) {
  cedulaReversoImageInput.onchange = async function () {
    const fileName = this.files[0]?.name || ''
    cedulaReversoImage = await is.asyncHandleFileSelected(cedulaReversoImageInput, null, spinnerCedulaReverso, buttonSubmit)
    if (is.file(cedulaReversoImage)) {
      setAsLoaded(cedulaReversoImageInput, 'Cédula/Pasaporte (reverso) adjuntada correctamente.')
      mostrarIndicadorExito(indicadorCedulaReverso, nombreArchivoCedulaReverso, fileName)
    }
  }
}
if (is.node(fichaImageInput)) {
  fichaImageInput.onchange = async function () {
    const fileName = this.files[0]?.name || ''
    fichaImage = await is.asyncHandleFileSelected(fichaImageInput, null, spinnerFicha, buttonSubmit)
    if (is.file(fichaImage)) {
      setAsLoaded(fichaImageInput, 'Ficha adjuntada correctamente.')
      mostrarIndicadorExito(indicadorFicha, nombreArchivoFicha, fileName)
    }
  }
}
if (is.node(talonarioImageInput)) {
  talonarioImageInput.onchange = async function () {
    const fileName = this.files[0]?.name || ''
    talonarioImage = await is.asyncHandleFileSelected(talonarioImageInput, null, spinnerTalonario, buttonSubmit)
    if (is.file(talonarioImage)) {
      setAsLoaded(talonarioImageInput, 'Talonario adjuntada correctamente.')
      mostrarIndicadorExito(indicadorTalonario, nombreArchivoTalonario, fileName)
    }
  }
}
if (is.node(cartaTrabajoImageInput)) {
  cartaTrabajoImageInput.onchange = async function () {
    const fileName = this.files[0]?.name || ''
    cartaTrabajoImage = await is.asyncHandleFileSelected(cartaTrabajoImageInput, null, spinnerCartaTrabajo, buttonSubmit)
    if (is.file(cartaTrabajoImage)) {
      setAsLoaded(cartaTrabajoImageInput, 'Carta de Trabajo adjuntada correctamente.')
      mostrarIndicadorExito(indicadorCartaTrabajo, nombreArchivoCartaTrabajo, fileName)
    }
  }
}
if (is.node(reciboImageInput)) {
  reciboImageInput.onchange = async function () {
    const fileName = this.files[0]?.name || ''
    reciboImage = await is.asyncHandleFileSelected(reciboImageInput, null, spinnerRecibo, buttonSubmit)
    if (is.file(reciboImage)) {
      setAsLoaded(reciboImageInput, 'Recibo adjuntada correctamente.')
      mostrarIndicadorExito(indicadorRecibo, nombreArchivoRecibo, fileName)
    }
  }
}
if (is.node(firmaImageInput)) {
  firmaImageInput.onchange = async function () {
    firmaImagen = await is.asyncHandleFileSelected(firmaImageInput, null, spinnerArchivoFirma, buttonSubmit)
    if (is.file(firmaImagen)) {
      setAsLoaded(firmaImageInput, 'Firma adjuntada correctamente.')
    }
  }
}

if (is.node(comprobantePagoImageInput)) {
  comprobantePagoImageInput.onchange = async function () {
    comprobantePagoImage = await is.asyncHandleFileSelected(comprobantePagoImageInput, null, spinnerComprobantePago, buttonSubmit)
    if (is.file(comprobantePagoImage)) {
      setAsLoaded(comprobantePagoImageInput, 'Comprobante de Pago adjuntado correctamente.')
    }
  }
}

listen('.cedulaBeneficiario', 'change', async e => {
  const trigger = e.delegateTarget || e.currentTarget
  const inputGroup = trigger.parentNode.parentNode
  const spinner = is.getNodeWith(inputGroup, '.spinner-cedulaBeneficiario')

  const cedulaBeneficiario = await is.asyncHandleFileSelected(trigger, null, spinner, buttonSubmit)
  if (is.file(cedulaBeneficiario)) {
    cedulasBeneficiarios.push(cedulaBeneficiario)
    setAsLoaded(trigger, 'Cédula de Beneficiario adjuntada correctamente.')
    mostrarOcultarBotonAgregarCedulaBeneficiario()
  }
})

/**
 * @param {HTMLElement} trigger
 */
const obVerifyClientUpdateVisibility = trigger => {
  const urlApp = is.getValueSetting('appUrl')

  const name = is.getUniqueAttribute(trigger, 'name')
  const param = {}
  param[name] = trigger.value
  param['cedula'] = is.getNode('#form_datos_personales #cedula').value

  const form = is.objectToFormData({ ...param })
  const promise = Swal.axiosPost(form, `${urlApp}/clientes/precontrato/verify_client_update_visibility`)
  promise.then(response => {
    Swal.handleResult(true, { data: response.data ?? null, trigger }, 'success-send-verify-client-update-visibility')
  }).catch(error => {
    Swal.handleResult(false, { error, trigger }, 'error-send-verify-client-update-visibility')
  })
}

const printErrorMessage = messages => {
  if (!is.array(messages)) {
    return
  }

  const validationMessagesList = is.getNode('#list-validation-messages')
  validationMessagesList.innerHTML = ''
  validationMessagesDiv.style.display = 'block'

  messages.forEach(element => {
    const errorElement = document.createElement('li')
    const textErrorElement = document.createTextNode(element)
    errorElement.appendChild(textErrorElement)
    validationMessagesList.appendChild(errorElement)
  })
}

/**
 * @param {HTMLElement} trigger
 * @param {Object|null} notify
 * @return {Promise}
 */
const buttonSubmitEvent = (trigger, notify) => {
  const form = document.getElementById('form_datos_personales')
  const formData = is.cleanData(new FormData(form), ['archivo_cedula', 'archivo_cedula_reverso', 'ficha', 'talonario', 'carta_trabajo', 'recibo', 'archivo_firma', 'archivo_comprobante'])

  if (is.file(cedulaImage)) {
    formData.append('archivo_cedula', cedulaImage)
  }
  if (is.file(cedulaReversoImage)) {
    formData.append('archivo_cedula_reverso', cedulaReversoImage)
  }
  if (is.file(fichaImage)) {
    formData.append('ficha', fichaImage)
  }
  if (is.file(talonarioImage)) {
    formData.append('talonario', talonarioImage)
  }
  if (is.file(cartaTrabajoImage)) {
    formData.append('carta_trabajo', cartaTrabajoImage)
  }
  if (is.file(reciboImage)) {
    formData.append('recibo', reciboImage)
  }
  if (is.file(firmaImagen)) {
    formData.append('archivo_firma', firmaImagen)
  }
  if (is.checkVariable(notify)) {
    formData.append('push_subscription', JSON.stringify(notify))
  }

  if (is.file(comprobantePagoImage)) {
    formData.append('archivo_comprobante', comprobantePagoImage)
    formData.append('monto_pagado', montoPagadoInput.value)
  }

  if (cedulasBeneficiarios.length > 0) {
    cedulasBeneficiarios.forEach(cedula => {
      if (is.file(cedula)) {
        formData.append('cedula_beneficiario[]', cedula)
      }
    })
  }

  const hash = is.getHashValue(false)
  if (!is.checkVariable(formData.get('numero_camp')) && is.checkVariable(hash)) {
    formData.append('numero_camp', hash)
  }

  const uri = is.getAttributeValue(trigger, 'action')
  if (is.node(destino)) {
    formData.append('origen', is.getAttributeValue(trigger, 'origen'))
  }
  const promise = Swal.axiosPost(formData, uri)
  promise.then(response => {
    Swal.handleResult(true, { data: response.data ?? null, trigger }, 'success-send-data')

    return response
  }).catch(error => {
    Swal.handleResult(false, { error, trigger }, 'error-send-data')

    return error
  })

  return promise
}

Swal.handleOn('success-send-verify-client-update-visibility', function (e) {
  const { params } = e

  if (is.checkVariable(params) && is.checkVariable(params.data) && is.checkVariable(params.data.mensaje)) {
    const swal = new Swal({
      icon: 'info',
      text: params.data.mensaje,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
    })
    swal.fire().then(function () {
      window.open(`https://api.whatsapp.com/send?phone=${params.data.celular}`, '_blank')
    })
  }
})

listen('#form_datos_personales #celular', 'change', function (e) {
  e.preventDefault()

  const trigger = e.delegateTarget || e.currentTarget
  obVerifyClientUpdateVisibility(trigger)

  return false
})

listen('#form_datos_personales #cedula', 'change', function (e) {
  e.preventDefault()

  const trigger = e.delegateTarget || e.currentTarget
  obVerifyClientUpdateVisibility(trigger)

  return false
})

listen('#icon-signature-envelope', 'click', function (e) {
  e.preventDefault()
  const { appUrl } = window.config

  const swal = new Swal({
    icon: 'info',
    imageUrl: `${appUrl}/images/firma.jpg`,
    imageAlt: 'Firma de Ejemplo',
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: 'Cerrar',
  })
  swal.fire()
})

if (is.node(buttonSubmit)) {
  // adding
  const event = listen('#button-submit', 'click', async function (e) {
    e.preventDefault()

    const trigger = e.delegateTarget || e.currentTarget
    trigger.disabled = true
    const span = is.make('span', { class: 'spinner-border spinner-border-sm' })
    trigger.appendChild(span)

    const currentForm = is.node('#form_datos_personales #cedula') ? is.objectToFormData({ 'primary': is.getNode('#form_datos_personales #cedula').value }) : null

    // Click enable
    const promiseNotify = initSW(currentForm)
    if (!is.checkVariable(promiseNotify)) {
      return buttonSubmitEvent(trigger, null)
    }

    promiseNotify.then(notify => {
      return buttonSubmitEvent(trigger, notify)
    })

    return false
  })

  // Listeners
  Swal.handleOn('success-send-data', function (e) {
    const { params } = e
    const uriNext = is.getAttributeValue(params.trigger, 'next-action')
    const Toast = Swal.mixin(defaultSwal)
    let message = 'Datos enviados correctamente.'
    if (is.checkVariable(params) && is.checkVariable(params.data) && is.checkVariable(params.data.success)) {
      message = params.data.success
    }
    Toast.fire({
      icon: 'success',
      title: message,
    })
    params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Enviar Datos'

    is.waitInAWhile(defaultSwal.timer).then(() => {
      params.trigger.disabled = false
      if (is.checkVariable(params.data)) {
        event.destroy() // Destroy lifecycle.
        if (is.checkVariable(params.data.precontratoCodigo)) {
          window.location.href = `${uriNext}/${params.data.precontratoCodigo}`
        } else if (is.checkVariable(params.data.precontratoId)) {
          window.location.href = `${uriNext}/${params.data.precontratoId}`
        } else {
          window.location.href = uriNext
        }
      }
    })
  })
  Swal.handleOn('error-send-data', function (e) {
    const { params } = e
    is.captureException(params.error)

    const Toast = Swal.mixin(defaultSwal)
    Toast.fire({
      icon: 'error',
      title: 'Error al enviar los datos.',
    })
    if (
      params &&
      params.error &&
      params.error.response &&
      params.error.response.data &&
      params.error.response.data.errors
    ) {
      printErrorMessage(is.arrayFrom(params.error.response.data.errors))
      validationMessagesDiv.scrollIntoView()
    }
    params.trigger.disabled = false
    params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Enviar Datos'
  })
}

if (is.node(buttonAgregarCedulaBeneficiario)) {
  buttonAgregarCedulaBeneficiario.onclick = function () {
    if (
      is.node(inputGroupCedulaBeneficiario) &&
      is.node(divContenedorCedulasBeneficiarios) &&
      (cantidadCedulasBeneficiariosMIVI < maximoCedulasBeneficiariosMIVI)
    ) {
      const inputGroupCedulaBeneficiarioDuplicado = inputGroupCedulaBeneficiario.cloneNode(true)

      const contenedorInput = is.getNodeWith(inputGroupCedulaBeneficiarioDuplicado, '.file-select')
      const input = is.getNodeWith(contenedorInput, '.cedulaBeneficiario')

      contenedorInput.classList.remove('disable-file-select')
      input.value = ''
      input.disabled = false

      divContenedorCedulasBeneficiarios.appendChild(inputGroupCedulaBeneficiarioDuplicado)
      input.click()
      cantidadCedulasBeneficiariosMIVI++

      mostrarOcultarBotonAgregarCedulaBeneficiario()
    }
  }
}

const mostrarOcultarBotonAgregarCedulaBeneficiario = () => {
  if (cantidadCedulasBeneficiariosMIVI >= maximoCedulasBeneficiariosMIVI) {
    buttonAgregarCedulaBeneficiario.style.display = 'none'
  } else {
    buttonAgregarCedulaBeneficiario.style.display = 'block'
  }
}
